module.exports = __webpack_public_path__ + "img/MapThumb_TeutoburgForest.86e9b64e.webp";